/* eslint-disable react/jsx-props-no-spreading */
import Featured from 'containers/privacyPolicy';
import Skeleton from 'components/layouts/Skeleton';

export default function PrivacyPolicyPage(props) {

  return (
    <Featured {...props} />
  );

}

PrivacyPolicyPage.getLayout = (page) => <Skeleton page={page}/>;

export const getServerSideProps = async (ctx) => {

  const { getFeaturedProps } = require('containers/api/termsAndPolicy');
  return getFeaturedProps(ctx);

};
